import { SustainableProductionProjectPage } from './pages/sustainableProduction/SustainableProductionProjectPage';

export const DetailsPage = () => {
  return <SustainableProductionProjectPage />;
};
